export default "__VITE_ASSET__B6zZJmB9__"